import React from 'react';

import svg from './assets/icons-32-shopping-bag.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconBasketSolid = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-basket-solid" />
);
